import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import "./Header1.css";

const SERVICES = [
  { to: "/automotivedesign", label: "Automotive Design" },
  { to: "/aiml", label: "AI/ML" },
  { to: "/cadautomation", label: "CAD Automation and Customization" },
  { to: "/computervision", label: "Computer Vision" },
  { to: "/digitalmarketing", label: "Digital Marketing" },
  { to: "/fullstack", label: "Full Stack" },
  { to: "/plmsolution", label: "PLM Solutions" },
];

function Header1() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const headerRef = useRef(null);
  const { pathname } = useLocation();

  // Close everything after navigating.
  useEffect(() => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
  }, [pathname]);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        setIsServicesOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsMenuOpen(false);
        setIsServicesOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    // `position: sticky` rather than toggling relative -> fixed on scroll,
    // which used to yank the page up by the header's height mid-scroll.
    <div className="site-header" ref={headerRef}>
      <div className="container site-header__inner">
        <Link to="/" className="site-header__logo" aria-label="Happy Technovation — home">
          {/* Absolute public paths: the old relative "HT_LOGO_1.png" resolved
              against the current route rather than the site root. */}
          <picture>
            <source srcSet="/HT_LOGO_1.webp" type="image/webp" />
            <img
              src="/HT_LOGO_1.png"
              alt="Happy Technovation"
              width="300"
              height="75"
              /* Above the fold on every page, so never lazy-loaded. */
              fetchpriority="high"
            />
          </picture>
        </Link>

        <button
          type="button"
          /* Was a <div onClick>: not focusable, not keyboard-operable and
             invisible to screen readers. */
          className={`site-header__toggle ${isMenuOpen ? "is-open" : ""}`}
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span className="site-header__bar" />
          <span className="site-header__bar" />
          <span className="site-header__bar" />
        </button>

        <nav
          id="primary-navigation"
          className={`site-nav ${isMenuOpen ? "is-open" : ""}`}
          aria-label="Main"
        >
          <ul className="site-nav__list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/staffing">Staffing</Link>
            </li>

            <li
              className={`site-nav__dropdown ${isServicesOpen ? "is-open" : ""}`}
            >
              <button
                type="button"
                /* Opening on click as well as hover: a hover-only submenu
                   cannot be opened at all on a touch screen. */
                className="site-nav__dropdown-trigger"
                aria-expanded={isServicesOpen}
                onClick={() => setIsServicesOpen((open) => !open)}
              >
                Services
                <ExpandMoreSharpIcon className="site-nav__chevron" />
              </button>
              <ul className="site-nav__dropdown-menu">
                {SERVICES.map((service) => (
                  <li key={service.to}>
                    <Link to={service.to}>{service.label}</Link>
                  </li>
                ))}
              </ul>
            </li>

            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/careers">Careers</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Header1;
